import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Divider } from '@ui/components/Divider'
import { Modal } from '@ui/components/Modal'
import { MobileIcon } from '@ui/icons/Mobile.icon'
import { TrashIcon } from '@ui/icons/Trash.icon'

import { ClientPhoneNumberDto } from '@model/AccountDetailedDto'

import { Box } from '@shared/components/Box'

interface PhoneNumberEditModalProps {
  phoneNumber: ClientPhoneNumberDto
  deleteNumber: (id: string) => void
  makeNumberPrimary: (id: string) => void
}

export const PhoneNumberEditModal: BaseModalType<PhoneNumberEditModalProps> = ({
  close,
  phoneNumber,
  deleteNumber,
  makeNumberPrimary,
}) => {
  const { t } = useTranslation()
  if (!phoneNumber) {
    return null
  }

  const handleMakePrimary = () => {
    makeNumberPrimary(phoneNumber.id)
    close()
  }

  const handleDelete = () => {
    deleteNumber(phoneNumber.id)
    close()
  }

  return (
    <Modal>
      <Modal.Header sensitive>{`${phoneNumber.countryCode}${phoneNumber.number}`}</Modal.Header>
      <Modal.Body>
        <Box onClick={handleMakePrimary} flex align='center' gap='x8'>
          <MobileIcon color='text-high-em' />
          <Modal.Body.Text>{t('PhoneNumbers.Set as primary')}</Modal.Body.Text>
        </Box>
        {!phoneNumber.isUsedIn2FA && (
          <>
            <Divider.Horizontal rounded />
            <Box onClick={handleDelete} flex align='center' gap='x8'>
              <TrashIcon color='text-danger-high-em' />
              <Modal.Body.Text>{t('PhoneNumbers.Delete')}</Modal.Body.Text>
            </Box>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
